<article class="bg-blue-gradient w-100 px-4 py-md-4">
  <h3 class="labelP mb-3">Información personal</h3>
  <hr />

  <!-- Datos documento de identidad -->
  <h5 class="labelS mb-3">Datos documento de identidad</h5>
  <form class="form" >
    <div class="row row-spacing">
      <div class="col-md-3 labelL">Tipo de documento</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ tipoDocumentoNombre | capitalize }}</span>
      </div>
      <div class="col-md-3 labelL">Número de documento</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ state.numeroDocumento }}</span>
      </div>
    </div>

    <div class="row row-spacing">
      <div class="col-md-3 labelL">Fecha de expedición</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ state.fechaExpedicionDocumento | date:'dd/MM/yyyy' }}</span>
      </div>
      <div class="col-md-3 labelL">Lugar de expedición</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ state.lugarExpedicionDocumento | capitalize }}</span>
      </div>
    </div>
  </form>

  <hr class="mt-5" />

  <!-- Datos generales y de residencia -->
  <h5 class="labelS mb-3">Datos generales y de residencia</h5>
  <form [formGroup]="personalForm" class="form">
    <div class="row row-spacing">
      <div class="col-md-3 labelL">Primer nombre</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ personalForm.value.primerNombre | capitalize }}</span>
      </div>
      <div class="col-md-3 labelL">Segundo nombre</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ personalForm.value.segundoNombre | capitalize }}</span>
      </div>
    </div>

    <div class="row row-spacing">
      <div class="col-md-3 labelL">Primer apellido</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ personalForm.value.primerApellido | capitalize }}</span>
      </div>
      <div class="col-md-3 labelL">Segundo apellido</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ personalForm.value.segundoApellido | capitalize }}</span>
      </div>
    </div>

    <div class="row row-spacing">
      <div class="col-md-3 labelL">Fecha de nacimiento</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ personalForm.value.fechaNacimiento | date:'dd/MM/yyyy' }}</span>
      </div>
      <div class="col-md-3 labelL">Lugar de nacimiento</div>
      <div class="col-md-3 datoB">
        <span class="text-white">{{ state.lugarNacimiento | capitalize }}</span>
      </div>
    </div>

    <div class="row row-spacing">
      <div class="col-md-6">
        <div class="labelL">Género</div>
        <div class="row">
          <div class="item col-md-6 text-white" *ngFor="let g of genders; let i = index"
            [ngClass]="{ active: activeGenderIndex === i }"
            (click)="activeGenderIndex = i; personalForm.get('genero')!.setValue(i + 1)">
            {{ g }}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="labelL">Estado civil</div>
        <select class="input__select" formControlName="estadoCivil">
          <option *ngFor="let ec of edoCivil" [ngValue]="ec.codigo">{{ ec.nombre | capitalize }}</option>
        </select>
      </div>
    </div>

    <div class="row row-spacing">
      <div class="col-md-6">
        <div class="labelL">Estudios realizados</div>
        <select class="input__select" formControlName="estudiosRealizados">
          <option *ngFor="let s of scholarship" [ngValue]="s.codigo">{{ s.nombre | capitalize }}</option>
        </select>
      </div>
    </div>

    <hr class="mt-5" />

    <!-- Datos de residencia -->
    <div class="row row-spacing">
      <div class="col-md-6">
        <div class="labelL">Departamento</div>
        <select class="input__select" formControlName="departamento" (change)="onDeptoChange()">
          <option *ngFor="let d of depOptions" [ngValue]="d.codigo">{{ d.nombre | capitalize }}</option>
        </select>
      </div>
      <div class="col-md-6">
        <div class="labelL">Ciudad</div>
        <select class="input__select" formControlName="ciudad">
          <option *ngFor="let c of cityOptions" [ngValue]="c.codigo">{{ c.nombre | capitalize }}</option>
        </select>
      </div>
    </div>

    <div class="row row-spacing">
      <div class="col-md-6 form-field">
        <label for="direccion" class="form-label">Dirección</label>
        <input id="direccion" class="form-control" formControlName="direccion" />
      </div>
      <div class="col-md-6">
        <div class="labelL">Tipo de vivienda</div>
        <select class="input__select" formControlName="tipoVivienda">
          <option *ngFor="let h of housing" [ngValue]="h.codigo">{{ h.nombre | capitalize }}</option>
        </select>
      </div>
    </div>
  </form>

  <hr class="mt-5" />

  <!-- Prestaciones sociales -->
  <h5 class="labelS mb-3">Datos prestaciones sociales</h5>
  <form [formGroup]="socialForm" class="form">
    <div class="row row-spacing">
      <div class="col-md-6 form-field">
        <label for="eps" class="form-label">EPS</label>
        <input type="text" id="eps" class="form-control" formControlName="eps" [value]="state.eps || ''"
          placeholder="EPS" readonly autocomplete="off" />
      </div>
      <div class="col-md-6 form-field">
        <label for="afp" class="form-label">AFP</label>
        <input type="text" id="afp" class="form-control" formControlName="afp" [value]="state.afp || ''"
          placeholder="AFP" readonly autocomplete="off" />
      </div>
    </div>
    <div class="row row-spacing">
      <div class="col-md-6 form-field">
        <label for="arl" class="form-label">ARL</label>
        <input type="text" id="arl" class="form-control" formControlName="arl" [value]="state.arl || ''"
          placeholder="ARL" readonly autocomplete="off" />
      </div>
    </div>
  </form>

  <hr class="mt-5" />

  <!-- Información financiera -->
  <h5 class="labelS mb-3">Datos información financiera</h5>
  <form [formGroup]="financialForm" class="form">
    <div class="row row-spacing">
      <div class="col-md-6 form-field">
        <label for="totalActivos" class="form-label">Total activos</label>
        <input id="totalActivos" class="form-control" formControlName="totalActivos" inputmode="numeric" currencyMask [options]="{suffix: ' COP'}" />
      </div>
      <div class="col-md-6 form-field">
        <label for="totalPasivos" class="form-label">Total pasivos</label>
        <input id="totalPasivos" class="form-control" formControlName="totalPasivos" inputmode="numeric" currencyMask [options]="{suffix: ' COP'}" />
      </div>
    </div>

    <div class="row row-spacing">
      <div class="col-md-6 form-field">
        <label for="gastos" class="form-label">Gastos mensuales</label>
        <input id="gastos" class="form-control" formControlName="gastos" inputmode="numeric" currencyMask [options]="{suffix: ' COP'}" />
        <div class="form-error" *ngIf="financialForm.controls.gastos.errors?.['required'] && !financialForm.controls.gastos.pristine" @growVertical>
          Este campo es obligatorio
        </div>
      </div>
      <div class="col-md-6 form-field">
        <label for="ingresos" class="form-label">Ingresos mensuales</label>
        <input id="ingresos" class="form-control" formControlName="ingresos" inputmode="numeric" currencyMask [options]="{suffix: ' COP'}" />
        <div class="form-error" *ngIf="financialForm.controls.ingresos.errors?.['required'] && !financialForm.controls.ingresos.pristine" @growVertical>
          Este campo es obligatorio
        </div>
      </div>
    </div>

    <div class="row row-spacing">
      <div class="col-md-6 form-field">
        <label for="otrosIngresos" class="form-label">Otros ingresos</label>
        <input id="otrosIngresos" class="form-control" formControlName="otrosIngresos" inputmode="numeric" currencyMask [options]="{suffix: ' COP'}" />
      </div>
      <div class="col-md-6 form-field">
        <label for="personasACargo" class="form-label">Personas a cargo</label>
        <input id="personasACargo" class="form-control" formControlName="personasACargo" />
      </div>
    </div>

    <!-- Alerta -->
    <div class="d-flex justify-content-center" *ngIf="showAdvertencia" @growVertical>
      <app-advertencias [color]="colorAdvertencia">{{textoAdvertencia}}</app-advertencias>
    </div>

    <!-- Botón -->
    <div class="d-flex justify-content-center">
      <button-look-feel color="secondary" (clicked)="onSaveAll()" [loading]="loadingAdvertencia" [disabled]="showAdvertencia || financialForm.invalid">Guardar</button-look-feel>
    </div>
  </form>
</article>